const fetchFixOrder = () => {
//this script created incase order logic becomes more complex currently unrequired
}
export {
fetchFixOrder
};